// extracted by mini-css-extract-plugin
export default {"markdownHeroContainer":"Readme-module__markdownHeroContainer--QghGJ","markdownHeroLogo":"Readme-module__markdownHeroLogo--AjJoL"};